import * as React from 'react'
import { SideDrawer } from '@sales-center/components'
import { useHandlers, useData, useValidation } from './hooks'
import { Formik } from 'formik'
import { FormFields } from './FormFields'

export function ActivityTypesForm() {
  const { handleCloseClick, handleSubmit } = useHandlers()
  const { isOpen, title, initValues } = useData()
  const { validate } = useValidation()

  return (
    <SideDrawer title={title} open={!!isOpen} onClose={handleCloseClick}>
      <Formik
        initialValues={initValues}
        onSubmit={handleSubmit}
        validate={validate}
      >
        <FormFields />
      </Formik>
    </SideDrawer>
  )
}
